import constate from 'constate';
import { useState } from 'react';

interface LessonSettingsProps {
  copilotEnabled?: boolean;
}

const _useLessonSettings = ({ copilotEnabled }: LessonSettingsProps) => {
  const [isFooterVisible, setFooterVisibility] = useState(true);

  return {
    isFooterVisible,
    setFooterVisibility,
    copilotEnabled,
  };
};

export const [LessonSettingsProvider, useLessonSettings] =
  constate(_useLessonSettings);
